import { AnimatedButton } from "../roles/components";
import { StyledChatLoaderContainer } from "../style";

export const ChatLoader = ({ width }: any) => {
  return (
    <StyledChatLoaderContainer style={width ? { width } : {}}>
      <AnimatedButton />
      {/* <img src={chatLoader} alt="" /> */}
    </StyledChatLoaderContainer>
  );
};
